// Exports of all known weblcient commands
// @Rank this is a guess, is this correct?
// `command://openSearch?scope=articles&id=[exhibitionID]`
// `command://openSearch?scope=articles&id=[exhibitionID]&sortBy=name`
// `command://openSearch?scope=articles&id=[exhibitionID]&sortBy=title`
export const openSearch = 'openSearch';
export const startSubModule = 'startSubModule';
export const stopSubModule = 'stopSubModule';
export const sendForm = 'sendForm';
export const galleryClose = 'galleryClose';
export const galleryJump = 'galleryJump';
export const galleryOpen = 'galleryOpen';
export const varIncrement = 'varIncrement';
export const varDecrement = 'varDecrement';
export const varSet = 'varSet';
export const varToggle = 'varToggle';
export const allowUserInput = 'allowUserInput';
export const glossary = 'glossary';
export const openInModal = 'openInModal';
export const showInModal = 'showInModal';
export const openModal = 'openModal';
export const showModal = 'showModal';
export const closeModal = 'closeModal';
export const hideModal = 'hideModal';
export const toggleModal = 'toggleModal';
// `command://setLang?lang=de`
// `command://setLanguage?language=fr`
// `command://setLanguage?lang=en`
// `command://setLang?language=kz`
export const setLang = 'setLang';
export const setLanguage = 'setLanguage';
// `command://setExhibitionLanding`
// set to current exhibtion and current article
export const setExhibitionLanding = 'setExhibitionLanding';
export const setArticle = 'setArticle';
export const addClass = 'addClass';
export const removeClass = 'removeClass';
export const toggleClass = 'toggleClass';
export const setExhibition = 'setExhibition';
export const startTour = 'startTour';
export const startTutorial = 'startTutorial';
export const setExhibitionList = 'setExhibitionList';
export const sendToCommand = 'sendToCommand';
export const resetSessionStorage = 'resetSessionStorage';
export const closeCustomerContent = 'closeCustomerContent';
export const openCustomerContent = 'openCustomerContent';
export const doMethodCall = 'doMethodCall';
export const setConfig = 'setConfig';
// `command://back`
export const back = 'back';
export const setFocus = 'setFocus';
export const geoLocationStart = 'geoLocationStart';
export const sharePage = 'sharePage';
export const noOp = 'noOp';
export const setFontSize = 'setFontSize';
export const contentOpen = 'contentOpen';
